/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExercisePrerequisiteDTO } from './ExercisePrerequisiteDTO';
import {
    ExercisePrerequisiteDTOFromJSON,
    ExercisePrerequisiteDTOFromJSONTyped,
    ExercisePrerequisiteDTOToJSON,
    ExercisePrerequisiteDTOToJSONTyped,
} from './ExercisePrerequisiteDTO';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';
import type { EquipmentConfig } from './EquipmentConfig';
import {
    EquipmentConfigFromJSON,
    EquipmentConfigFromJSONTyped,
    EquipmentConfigToJSON,
    EquipmentConfigToJSONTyped,
} from './EquipmentConfig';
import type { MuscleIntensity } from './MuscleIntensity';
import {
    MuscleIntensityFromJSON,
    MuscleIntensityFromJSONTyped,
    MuscleIntensityToJSON,
    MuscleIntensityToJSONTyped,
} from './MuscleIntensity';
import type { SupportExerciseDTO } from './SupportExerciseDTO';
import {
    SupportExerciseDTOFromJSON,
    SupportExerciseDTOFromJSONTyped,
    SupportExerciseDTOToJSON,
    SupportExerciseDTOToJSONTyped,
} from './SupportExerciseDTO';

/**
 * 
 * @export
 * @interface UpdateExerciseDTO
 */
export interface UpdateExerciseDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateExerciseDTO
     */
    difficulty?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    imageId?: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof UpdateExerciseDTO
     */
    config: ExerciseConfig;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    videoId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    youtubeVideoId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseDTO
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {Array<MuscleIntensity>}
     * @memberof UpdateExerciseDTO
     */
    muscleIntensities: Array<MuscleIntensity>;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof UpdateExerciseDTO
     */
    links: Array<HTTPLink>;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    mainBodyZoneId: string;
    /**
     * 
     * @type {Array<EquipmentConfig>}
     * @memberof UpdateExerciseDTO
     */
    equipment: Array<EquipmentConfig>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseDTO
     */
    additionalImageIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateExerciseDTO
     */
    publiclyVisible?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseDTO
     */
    progressionExerciseIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseDTO
     */
    regressionExerciseIds: Array<string>;
    /**
     * 
     * @type {Array<SupportExerciseDTO>}
     * @memberof UpdateExerciseDTO
     */
    supportExercises: Array<SupportExerciseDTO>;
    /**
     * 
     * @type {Array<ExercisePrerequisiteDTO>}
     * @memberof UpdateExerciseDTO
     */
    prerequisites: Array<ExercisePrerequisiteDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseDTO
     */
    exerciseFactIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseDTO
     */
    synonyms?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateExerciseDTO
     */
    isUniLateral?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseDTO
     */
    id: string;
}

/**
 * Check if a given object implements the UpdateExerciseDTO interface.
 */
export function instanceOfUpdateExerciseDTO(value: object): value is UpdateExerciseDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('categoryIds' in value) || value['categoryIds'] === undefined) return false;
    if (!('muscleIntensities' in value) || value['muscleIntensities'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('mainBodyZoneId' in value) || value['mainBodyZoneId'] === undefined) return false;
    if (!('equipment' in value) || value['equipment'] === undefined) return false;
    if (!('progressionExerciseIds' in value) || value['progressionExerciseIds'] === undefined) return false;
    if (!('regressionExerciseIds' in value) || value['regressionExerciseIds'] === undefined) return false;
    if (!('supportExercises' in value) || value['supportExercises'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateExerciseDTOFromJSON(json: any): UpdateExerciseDTO {
    return UpdateExerciseDTOFromJSONTyped(json, false);
}

export function UpdateExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'difficulty': json['difficulty'] == null ? undefined : json['difficulty'],
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'config': ExerciseConfigFromJSON(json['config']),
        'videoId': json['videoId'] == null ? undefined : json['videoId'],
        'youtubeVideoId': json['youtubeVideoId'] == null ? undefined : json['youtubeVideoId'],
        'categoryIds': json['categoryIds'],
        'muscleIntensities': ((json['muscleIntensities'] as Array<any>).map(MuscleIntensityFromJSON)),
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
        'mainBodyZoneId': json['mainBodyZoneId'],
        'equipment': ((json['equipment'] as Array<any>).map(EquipmentConfigFromJSON)),
        'additionalImageIds': json['additionalImageIds'] == null ? undefined : json['additionalImageIds'],
        'publiclyVisible': json['publiclyVisible'] == null ? undefined : json['publiclyVisible'],
        'progressionExerciseIds': json['progressionExerciseIds'],
        'regressionExerciseIds': json['regressionExerciseIds'],
        'supportExercises': ((json['supportExercises'] as Array<any>).map(SupportExerciseDTOFromJSON)),
        'prerequisites': ((json['prerequisites'] as Array<any>).map(ExercisePrerequisiteDTOFromJSON)),
        'exerciseFactIds': json['exerciseFactIds'] == null ? undefined : json['exerciseFactIds'],
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
        'isUniLateral': json['isUniLateral'] == null ? undefined : json['isUniLateral'],
        'id': json['id'],
    };
}

export function UpdateExerciseDTOToJSON(json: any): UpdateExerciseDTO {
    return UpdateExerciseDTOToJSONTyped(json, false);
}

export function UpdateExerciseDTOToJSONTyped(value?: UpdateExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'difficulty': value['difficulty'],
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'config': ExerciseConfigToJSON(value['config']),
        'videoId': value['videoId'],
        'youtubeVideoId': value['youtubeVideoId'],
        'categoryIds': value['categoryIds'],
        'muscleIntensities': ((value['muscleIntensities'] as Array<any>).map(MuscleIntensityToJSON)),
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
        'mainBodyZoneId': value['mainBodyZoneId'],
        'equipment': ((value['equipment'] as Array<any>).map(EquipmentConfigToJSON)),
        'additionalImageIds': value['additionalImageIds'],
        'publiclyVisible': value['publiclyVisible'],
        'progressionExerciseIds': value['progressionExerciseIds'],
        'regressionExerciseIds': value['regressionExerciseIds'],
        'supportExercises': ((value['supportExercises'] as Array<any>).map(SupportExerciseDTOToJSON)),
        'prerequisites': ((value['prerequisites'] as Array<any>).map(ExercisePrerequisiteDTOToJSON)),
        'exerciseFactIds': value['exerciseFactIds'],
        'synonyms': value['synonyms'],
        'isUniLateral': value['isUniLateral'],
        'id': value['id'],
    };
}

